import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./accordion.css";
import Lines from "./lines";
import { handleDeletePolygon } from "../DSFunction";
import { updateQuantityInfo } from "../../../../Features/quantityInfo";
import { editRoof } from "./accordionFunction";
import { updateDesignParameter } from "../../../../Features/designParameter";

export default function RoofAccordion() {
  const [tooltip, setTooltip] = useState();

  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const designParameter = useSelector((state) => state.designParameter);
  const quantityInfo = useSelector((state) => state.quantity);

  const polygon = roofInfo?.value?.polygonCoordinates || [];

  return (
    <div className="ac-main">
      <h1
        onClick={() =>
          dispatch(
            updateDesignParameter({
              roofAccordion: !designParameter.roofAccordion,
            })
          )
        }
      >
        <span>Select Roof</span>
        <i
          className={
            designParameter.roofAccordion ? `bi bi-chevron-up` : `bi bi-chevron-down`
          }
        ></i>
      </h1>
      {designParameter.roofAccordion && (
        <>
          {polygon.length > 0 ? (
            polygon.map((item, i) => (
              <div key={i}>
                <div className="ac-roof">
                  <div
                    className="ac-title"
                    onClick={() =>
                      dispatch(
                        updateQuantityInfo({ roofNo: i, allRoof: false })
                      )
                    }
                  >
                    <img
                      src="../images/icons/roofIcon.svg"
                      alt="roofIcon"
                    ></img>
                    <span
                      style={{
                        color: quantityInfo.roofNo === i ? "orange" : "",
                      }}
                    >
                      Roof {i + 1}
                    </span>
                  </div>
                  <div className="ac-action">
                    <div className="actionBtn">
                      {tooltip === `Edit${i}` && (
                        <h4 className="warning">
                          <div className="sideArrow"></div>
                          Edit Roof
                        </h4>
                      )}
                      <i
                        className="bi bi-pencil-fill"
                        style={{
                          color:
                            designParameter.polygonEdit &&
                            quantityInfo.roofNo === i
                              ? "orange"
                              : "",
                        }}
                        onClick={() =>
                          editRoof({
                            i,
                            dispatch,
                            designParameter,
                            quantityInfo,
                          })
                        }
                        onMouseEnter={() => setTooltip(`Edit${i}`)}
                        onMouseLeave={() => setTooltip()}
                      ></i>
                    </div>
                    <div className="actionBtn">
                      {tooltip === `delete${i}` && (
                        <h4 className="warning">
                          <div className="sideArrow"></div>
                          Delete Roof
                        </h4>
                      )}
                      <i
                        className="bi bi-trash-fill trashIcon"
                        onClick={() => {
                          setTooltip();
                          handleDeletePolygon(
                            i,
                            polygon,
                            dispatch,
                            quantityInfo
                          );
                        }}
                        onMouseEnter={() => setTooltip(`delete${i}`)}
                        onMouseLeave={() => setTooltip()}
                      ></i>
                    </div>
                  </div>
                </div>
                {designParameter.polygonEdit && i === quantityInfo.roofNo && (
                  <Lines points={polygon.updatedPoints} index={i}></Lines>
                )}
              </div>
            ))
          ) : (
            <li>
              <img src="../images/icons/polygonAdd.svg" alt="obstacle"></img>
              <span>Use this icon to draw roof</span>
            </li>
          )}
        </>
      )}
    </div>
  );
}
